// GoogleContext.js - Context để quản lý Facebook auth toàn cục
/* eslint-disable @typescript-eslint/naming-convention */

import { createContext } from 'react';
import useGoogle from '../hooks/useGoogle';
// import FacebookService from './services/facebookService';
// import apiService from './services/apiService';

export const GoogleContext = createContext(null);

export const GoogleProvider = ({ children }) => {
  const {
    // State
    isLoading,
    isLoggedIn,
    userData,
    code,
    error,

    // Methods
    login,
    logout,
    // refreshStatus,
    // callAPI,
  } = useGoogle();

  const value = {
    // State
    isLoading,
    isLoggedIn,
    userData,
    code,
    error,

    // Methods
    login,
    logout,
    // refreshStatus,
    // callAPI,
  };

  return (
    <GoogleContext.Provider value={value}>{children}</GoogleContext.Provider>
  );
};
